import { Component, Inject } from '@angular/core';
import { MODAL_DATA, NgbActiveModal } from '@agilent/ui-element';
import Utils from '@app/utils/utils';

@Component({
    template: `
        <ag-dialog [header]="isWarningDialog? '':dialogTitle">
            <div class="modal-warning-header" *ngIf="isWarningDialog">
                <ag-icon-wrapper iconName="warning-icon"></ag-icon-wrapper>
                <h2 class="h2-title">WARNING: {{dialogTitle}}</h2>
            </div>
            <ag-dialog-content>
                <div [innerHTML]="content"></div>
            </ag-dialog-content>
            <ag-dialog-actions>
                <ag-button
                    id="cancel-btn"
                    *ngIf="cancelButtonText"
                    type="secondary"
                    (click)="cancel()"
                    [value]="cancelButtonText"></ag-button>
                <ag-button
                    id="confirm-btn"
                    type="primary"
                    (click)="confirm()"
                    [value]="confirmButtonText"></ag-button>
            </ag-dialog-actions>
        </ag-dialog>
    `,
    styles: [
            `
            .modal-warning-header {
                display: flex;
                flex-direction: row;
            }

            .h2-title {
                font-size: 1.375rem;
                color: #53565A;
                margin-left: 10px;
                font-weight: 600;
            }
        `
    ]
})
export class InfoDialogComponent {
    dialogTitle: string;
    content: string;
    cancelButtonText: string;
    confirmButtonText = 'Confirm';
    isWarningDialog = false;

    constructor(
        private activeModal: NgbActiveModal,
        @Inject(MODAL_DATA) private modalData: any
    ) {
        this.dialogTitle = modalData.title;
        this.content = modalData.content;
        this.cancelButtonText = modalData.cancelButtonText;
        this.confirmButtonText = modalData.confirmButtonText;
        this.isWarningDialog = modalData.isWarningDialog;
    }

    async confirm() {
        this.activeModal.close('confirmed');
    }

    cancel() {
        this.activeModal.dismiss();
    }
}
